import React from "react";
import "../Assets/styles/newStyles/Popup.css";

const Popup = ({ message, onClose, show }) => {
  if (!show) return null;
  return (
    <div className="popup">
      <div className="popup-content">
        <p onClick={onClose} style={{cursor:'pointer'}}>{message}</p>
        <span className="close" onClick={onClose}>
          &times;
        </span>
      </div>
    </div>
  );
};
export default Popup;
